<template>
  <div class="table-row c-float">
    <div v-if="checkbox" class="table-cell small">
      <Skeleton
        width="10px"
        height="10px" />
    </div>
    <div v-if="type" class="table-cell small">
      <Skeleton
        circle
        width="25px"
        height="25px" />
    </div>
    <div
      class="table-cell"
      v-for="(item, index) in data"
      :key="`row-${index}`">
        <Skeleton
          height="10px"
          width="80%"
          :count="2"
        />
    </div>
  </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton';

export default {
  name: 'TableRowSkeleton',
  components: {
    Skeleton,
  },
  props: ['checkbox', 'data', 'type'],
  data() {
    return {
      selected: false,
    };
  },
}
</script>
